import { render, staticRenderFns } from "./Competition.vue?vue&type=template&id=986d46b4&"
import script from "./Competition.vue?vue&type=script&lang=js&"
export * from "./Competition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports